import { Suspense } from 'react';

import { TAccount } from '@helpers/Accounts/accounts.types';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';

import { BackToDashboard } from './BackToDashboard';
import { RblTopUpForm } from './rblTopUpForm/rblTopUpForm';
import { useGetTopupRequestData } from './useGetTopupRequestData';
import FallbackErrorModal from '../modals/fallbackErrorModal/FallbackErrorModal';
import { TopUpForm } from '../multiLoanDashboard/NewOutstandingView/TopUpForm/TopUpForm';
import MainContentPending from '../pageStructure/mainContentPending';
import { TopUpChoiceForm } from './TopUpChoiceForm/TopUpChoiceForm';
import { useNewTopUpDesignSplitTest } from './TopUpChoiceForm/useNewTopUpDesignSplitTest';

export const TopupRequest = () => {
    const location = getCurrentLocation();

    const accountId: TAccount['account_id'] = getQueryParameter(
        location,
        'accountId'
    );

    if (!accountId) {
        return <FallbackErrorModal />;
    }
    return (
        <Suspense fallback={<MainContentPending />}>
            <TopupForm accountId={accountId} />
        </Suspense>
    );
};

const TopupForm = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    const { isRBL } = useGetTopupRequestData(accountId);
    const { branch } = useNewTopUpDesignSplitTest();

    if (isRBL) {
        return (
            <div className="bg-structure-100 px-[15%] py-xl max-sm:px-[5%]">
                <RblTopUpForm accountId={accountId} />
            </div>
        );
    }

    if (branch === 'INCLUDE') {
        return (
            <div className="min-h-screen-offset bg-secondary-95 px-m pb-2xl">
                <div className="mx-auto max-w-[960px] pt-l">
                    <TopUpChoiceForm accountId={accountId} />
                </div>
            </div>
        );
    }

    return (
        <div className="bg-structure-100 px-[15%] py-xl max-sm:px-[5%]">
            <TopUpForm accountId={accountId} formHeader={<BackToDashboard />} />
        </div>
    );
};
